<template>
  <div class="feed-page">
    <header-mobile-page label="Family Feed" />
    <Feed class="feed" />
    <router-link v-if="this.$mq === 'mobile'"
                 class="overview-feed-link"
                 :to="{ name: 'overview' }">
      <base-fab icon="icon-overview" iconColor="#fff" />
    </router-link>
  </div>
</template>

<script>
  import Feed from '@/components/Feed/Feed.vue'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  export default {
     components: {
      Feed,
      HeaderMobilePage
    }
  }
</script>

<style lang="scss" scoped>
  .feed-page {
    height: 100%;
    width: 100%;
    padding: 0 0 0 10px;

    .feed :deep(.scroll-area) {
        margin-top: 0px;
    }
  }
</style>
